import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
export default function ColorModeSelect(props?: any) {
  const { mode, setMode } = useColorScheme();
  if (!mode) return null;

  const handleChange = (event: React.MouseEvent<HTMLElement>, newMode: 'system' | 'light' | 'dark' | null) => {
    if (newMode !== null) {
      setMode(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleChange}
      sx={{
        borderRadius: 2,
        boxShadow: (theme) => theme.shadows[1],
        '& .MuiToggleButton-root': {
          border: 'none',
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
          },
        },
        ...props?.sx,
      }}
      {...props}
    >
     

      <ToggleButton value="light" aria-label="light">
        <LightModeIcon />
      </ToggleButton>
      <ToggleButton value="dark" aria-label="dark">
        <DarkModeIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
